import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {isMobile} from 'react-device-detect';

import CreditCardsField from './IncomeExpenses/CreditCardsField';
import IncomeField from './IncomeExpenses/IncomeField';
import LoansField from './IncomeExpenses/LoansField';
import RentField from './IncomeExpenses/RentField';

class IncomeExpenseFields extends Component {
  render() {
    return (
      <div>
        <IncomeField income={this.props.income} handleChange={this.props.handleChange} onBlur={this.props.validateField} error={this.props.validation.income.isInvalid} errorMessage={this.props.validation.income.message} autoFocus={!isMobile} />   
        <p>How much do you usually pay per month for the following?</p>
        <RentField rent={this.props.rent} handleChange={this.props.handleChange} onBlur={this.props.validateField} error={this.props.validation.rent.isInvalid} errorMessage={this.props.validation.rent.message} />
        <LoansField loans={this.props.loans} handleChange={this.props.handleChange} onBlur={this.props.validateField} error={this.props.validation.loans.isInvalid} errorMessage={this.props.validation.loans.message} />
        <CreditCardsField creditcards={this.props.creditcards} handleChange={this.props.handleChange} onBlur={this.props.validateField} error={this.props.validation.creditcards.isInvalid} errorMessage={this.props.validation.creditcards.message} />
      </div>);
  }
}
IncomeExpenseFields.defaultProps= {
  handleChange:() => {}
};

IncomeExpenseFields.propTypes = {
  handleChange: PropTypes.func,
};

export default IncomeExpenseFields;


// WEBPACK FOOTER //
// ./src/components/Fields/IncomeExpenseFields.js